export default __webpack_public_path__ + "static/media/smoothing.dcdc71e2.png";